module.exports = __webpack_public_path__ + "img/footer-bg.244247ab.png";